import type { ApiClient } from '@travel/api-client';
import { MONTEROSA_API_TIMEOUT } from '@travel/traveler-core/constants';

import type { ProviderRatePlan } from 'ProviderRatePlan-Types';

import type { SearchRequestBody } from '../../pages/ProviderInformationPage/resolver';

export const fetchAll = (http: ApiClient, req: SearchRequestBody): Promise<ProviderRatePlan> =>
  http.post(`/monterosa-api/v2/providers/item-plan-summaries`, {
    values: req,
    ignoreCommonErrorHandler: true,
    timeout: MONTEROSA_API_TIMEOUT,
  });
